import React from 'react';
import './StoreBenefit.scss';

const storeBenefits = [
  {
    text: '1 Year Warranty',
    img: 'https://static.lenskart.com/owndays/img/pdp/store-benefit-01.svg',
  },
  {
    text: 'Lifetime fitting & cleaning',
    img: 'https://static.lenskart.com/owndays/img/pdp/store-benefit-02.svg',
  },
  {
    text: 'Free eye test',
    img: 'https://static.lenskart.com/owndays/img/pdp/store-benefit-03.svg',
  },
  {
    text: '1 day free delivery',
    img: 'https://static.lenskart.com/owndays/img/pdp/store-benefit-04.svg',
  },
];

function StoreBenefit() {
  return (
    <div className="store-benefit">
      <h5 className="store-benefit__title">Store benefit</h5>
      {storeBenefits && (
        <ul className="store-benefit__list">
          {storeBenefits?.map(storeBenefit => (
            <li key={storeBenefit?.text}>
              <img alt={storeBenefit?.text} loading="lazy" src={storeBenefit?.img} />
              <span>{storeBenefit?.text}</span>
            </li>
          ))}
        </ul>
      )}
      <div className="store-benefit__locations">
        <h6 className="store-benefit__locations-title">Find Nearby Stores</h6>
        <div className="store-benefit__locations-tags">
          <span>Free eye test</span>
          <span>Lifetime service</span>
        </div>
        <a
          className="store-benefit__locations-link odButton odButton--white odButton--outline"
          href="/stores/sg"
        >
          STORE LOCATIONS
        </a>
      </div>
    </div>
  );
}

export default StoreBenefit;
